import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

// Import the generated route tree
import { getSharedConfig } from "@repo/config/sharedConfig";
import { App } from "./App";

const rootElement = document.getElementById("root")!;

// We can't use structured logging here since the LoggerProvider isn't available yet
const config = getSharedConfig(import.meta.env.MODE);
console.info("App starting with config:", {
	mode: import.meta.env.MODE,
	webAppBaseDomain: config.webAppBaseDomain,
	serverUrl: config.serverUrl,
	environment: config.environment,
});

if (!rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<StrictMode>
			<App />
		</StrictMode>,
	);
}
